import React, { useEffect, useState } from 'react'
import DOMPurify from 'dompurify'
import ErrorBoundary from '../../../../components/FundDetails/Modules/Performance/ErrorBoundary.jsx'
import { getLocalPath } from '../../../utility/config/configuration'
import { isInvestor } from '../../../../global/authentication/authentication-manager.js'
import { fetcher } from '../../productDetail/Helper.js'
const getApiBasePath = () => `${getLocalPath()}/halapi/documents`

function IndexDescriptionGlossary() {
  const [bodyData, setBodyData] = useState({})
  const [headerLinks, setHeaderLinks] = useState([])

  const customSort = (arr) => {
    const strings = arr
      .filter((item) => isNaN(Number(item)) && typeof item === 'string')
      .sort()
    const numbers = arr
      .filter((item) => !isNaN(Number(item)))
      .sort((a, b) => a - b)
    return [...strings, ...numbers]
  }

  const getAllContent = async () => {
    const url = `${getApiBasePath()}?_scope=/content/documents/${
      isInvestor() ? 'cti-investor' : 'cti-advisor'
    }/products/index-description-glossary-spa/body-content&_fields=title,summary&_limit=-1`
    const response = (await fetcher(url))?._embedded?.documents || []
    const data = response?.reduce(
      (p, n) => ({
        ...p,
        [n?.title]: {
          title: n?.title,
          summary: n?.summary?.content,
        },
      }),
      {}
    )
    const alphabat = [...Array(26)].map((_, i) => String.fromCharCode(i + 65))
    const headerLinksData = Object.keys(data).reduce(
      (p, n) => (p.includes(n) ? p : [...p, n]),
      [...alphabat]
    )
    setHeaderLinks(customSort(headerLinksData))
    setBodyData(data)
  }

  useEffect(() => {
    getAllContent()
  }, [])

  return (
    <div className="u-sizeConstrained Content">
      <div className="u-paddingTop12gu">
        {headerLinks?.map((itm) => (
          <React.Fragment key={itm}>
            {Object?.keys(bodyData).includes(itm) ? (
              <a href={DOMPurify.sanitize(`#${itm}`)}>{itm}</a>
            ) : (
              itm
            )}
            &nbsp;&nbsp;&nbsp;&nbsp;
          </React.Fragment>
        ))}
      </div>
      <div className="u-paddingTop12gu">
        {customSort(Object?.keys(bodyData)).map((itm) => (
          <div key={itm} id={itm}>
            <h3 className=" u-marginBottom1gu u-marginTop2gu ">{itm}</h3>
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(bodyData[itm]?.summary),
              }}
            />
            <a href="#top">Top</a>
          </div>
        ))}
      </div>
    </div>
  )
}

export function IndexDescriptionGlossaryContainer() {
  return (
    <ErrorBoundary
      title="Index Description Glossary"
      message="Index Description Glossary information is currently unavailable due to a technical issue. Please try again later."
      isConstrained={true}
    >
      <IndexDescriptionGlossary />
    </ErrorBoundary>
  )
}
